'use client';

import { FC } from 'react';
import Image from 'next/image';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { COLORS } from '@/constants';
import wlasBgImage from '@/assets/img/wlas_bg_image.png';
import { WlasEmbedIcon, WlasPaletteIcon, WlasSnippetIcon } from '@/components';
import {
  IntroCard,
  IntroFeatureIcon,
  IntroFeatureItem,
  IntroFeatureText,
  IntroFeatures,
  IntroGrid,
  IntroHero,
  IntroHeroContent,
  IntroHeroImage,
} from './styled';

export const WlasIntroCard: FC = () => {
  const t = useTranslations('wlasWidget');

  return (
    <IntroCard>
      <IntroHero>
        <IntroHeroContent>
          <Typography fontSize={20} fontWeight={700} color={COLORS.white} lineHeight={1.2}>
            {t('intro.heading')}
          </Typography>
          <Typography fontSize={14} color={COLORS['primary/200']} lineHeight={1.6}>
            {t('intro.body')}
          </Typography>
        </IntroHeroContent>
        <IntroHeroImage>
          <Image
            src={wlasBgImage}
            alt=""
            fill
            style={{ objectFit: 'cover', objectPosition: 'left center' }}
          />
        </IntroHeroImage>
      </IntroHero>

      <IntroFeatures>
        <IntroGrid>
          <IntroFeatureItem>
            <IntroFeatureIcon>
              <WlasEmbedIcon />
            </IntroFeatureIcon>
            <IntroFeatureText>
              <Typography fontSize={14} fontWeight={600} color={COLORS['primary/900']}>
                {t('intro.feature1.title')}
              </Typography>
              <Typography fontSize={14} color={COLORS['neutral/500']} lineHeight={1.5}>
                {t('intro.feature1.desc')}
              </Typography>
            </IntroFeatureText>
          </IntroFeatureItem>
          <IntroFeatureItem>
            <IntroFeatureIcon>
              <WlasPaletteIcon />
            </IntroFeatureIcon>
            <IntroFeatureText>
              <Typography fontSize={14} fontWeight={600} color={COLORS['primary/900']}>
                {t('intro.feature2.title')}
              </Typography>
              <Typography fontSize={14} color={COLORS['neutral/500']} lineHeight={1.5}>
                {t('intro.feature2.desc')}
              </Typography>
            </IntroFeatureText>
          </IntroFeatureItem>
          <IntroFeatureItem>
            <IntroFeatureIcon>
              <WlasSnippetIcon />
            </IntroFeatureIcon>
            <IntroFeatureText>
              <Typography fontSize={14} fontWeight={600} color={COLORS['primary/900']}>
                {t('intro.feature3.title')}
              </Typography>
              <Typography fontSize={14} color={COLORS['neutral/500']} lineHeight={1.5}>
                {t('intro.feature3.desc')}
              </Typography>
            </IntroFeatureText>
          </IntroFeatureItem>
        </IntroGrid>
      </IntroFeatures>
    </IntroCard>
  );
};
